import * as CANNON from 'cannon-es';

export const world = new CANNON.World({gravity:new CANNON.Vec3(0,-24,0)});
world.broadphase = new CANNON.SAPBroadphase(world); world.allowSleep = true;
export const physMat = new CANNON.Material('d');
world.addContactMaterial(new CANNON.ContactMaterial(physMat, physMat, {friction:0.7, restitution:0.05}));
export const groundBody = new CANNON.Body({mass:0, material:physMat, shape:new CANNON.Plane()});
groundBody.quaternion.setFromEuler(-Math.PI/2,0,0); world.addBody(groundBody);

